// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"98":"bfb21275","424":"12bbf146","597":"f46d8330","882":"79a98e07","937":"af4f1db5"}[chunkId] + ".css";
};